'use strict';

var Axios = require('axios');
var auth = require('@nextcloud/auth');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Axios__default = /*#__PURE__*/_interopDefaultLegacy(Axios);

var _a;
var client = Axios__default["default"].create({
    headers: {
        requesttoken: (_a = auth.getRequestToken()) !== null && _a !== void 0 ? _a : ''
    }
});
var cancelableClient = Object.assign(client, {
    CancelToken: Axios__default["default"].CancelToken,
    isCancel: Axios__default["default"].isCancel,
});
auth.onRequestTokenUpdate(function (token) { return client.defaults.headers.requesttoken = token; });

module.exports = cancelableClient;
//# sourceMappingURL=index.js.map
